<div class="dialog-form-upsert">
  <!-- Header -->
  <header class="dialog-form-upsert__header">
    <div class="dialog-form-upsert__heading">
      <ui-atom-text type="title" [text]="data.title"> </ui-atom-text>
      @if (data.message) {
        <ui-atom-text type="small" [text]="data.message" class="dialog-form-upsert__message">
        </ui-atom-text>
      }
    </div>
    <button
      type="button"
      class="dialog-form-upsert__expand"
      [attr.aria-label]="isExpanded ? 'Collapse dialog' : 'Expand dialog'"
      (click)="toggleExpanded()"
    >
      <mat-icon>{{ isExpanded ? 'close_fullscreen' : 'open_in_full' }}</mat-icon>
    </button>
  </header>

  <!-- Body con scroll único -->
  <main class="dialog-form-upsert__body">
    <!-- Form Name Input -->
    <form class="dialog-form-upsert__form" [formGroup]="form">
      <div class="dialog-form-upsert__field">
        <ui-molecule-input
          #nameInput
          textId="formName"
          formControlName="name"
          label="{{ 'forms.form.name.label' | translate }}"
          placeholder="{{ 'forms.form.name.placeholder' | translate }}"
          [required]="true"
          [maxLength]="nameMax"
          [errorMessage]="nameErrorKey ? (nameErrorKey | translate: { max: nameMax }) : null"
        >
        </ui-molecule-input>
      </div>
    </form>

    <!-- Survey Creator for form design -->
    <div class="dialog-form-upsert__creator">
      @if (surveyCreator) {
        <survey-creator [model]="surveyCreator"></survey-creator>
      }
    </div>

    <!-- Error Message -->
    @if (errorMessage) {
      <div class="dialog-form-upsert__error">
        <ui-atom-text type="small" [text]="errorMessage"> </ui-atom-text>
      </div>
    }
  </main>

  <!-- Footer · CTAs siempre visibles -->
  <footer class="dialog-form-upsert__footer">
    <ui-atom-button
      type="button"
      rules="main"
      styling="outlined"
      [withShadow]="false"
      [text]="'common.cancel' | translate"
      [disabled]="isLoading"
      (buttonClick)="onCancel()"
    >
    </ui-atom-button>

    <ui-atom-button
      type="button"
      rules="main"
      styling="filled"
      [withShadow]="true"
      [text]="data.mode === 'edit' ? ('common.save' | translate) : ('common.create' | translate)"
      [disabled]="isLoading || form.invalid"
      (buttonClick)="submit()"
    >
    </ui-atom-button>
  </footer>
</div>
